function checkAndShowMixedCartModal(response) {
  const sectionsHtml = response && response.sections && response.sections['cart-drawer'];
  if (!sectionsHtml) return;
  const tempDoc = new DOMParser().parseFromString(sectionsHtml, 'text/html');
  if (tempDoc.querySelector('[data-mixed-pickup="true"]')) {
    const modal = document.getElementById('MixedCart-InfoModal');
    if (modal) modal.hidden = false;
  }
}

function checkAndShowWHSKUModal(response) {
  const addedType = response && response.properties && response.properties.Type;
  const addedTypeLower = typeof addedType === 'string' ? addedType.toLowerCase() : '';
  const isAddedNoticeType = addedTypeLower.includes('whsku') || addedTypeLower.includes('nib');
  if (!isAddedNoticeType) return;

  const sectionsHtml = response && response.sections && response.sections['cart-drawer'];
  if (!sectionsHtml) return;
  const tempDoc = new DOMParser().parseFromString(sectionsHtml, 'text/html');
  if (tempDoc.querySelector('[data-whsku-only="true"]')) {
    const renderedModal = tempDoc.getElementById('WHSKU-InfoModal');
    const modal = document.getElementById('WHSKU-InfoModal');
    if (!modal) return;

    // Use fresh section-rendered modal markup so the message reflects the latest cart tags.
    if (renderedModal) modal.innerHTML = renderedModal.innerHTML;
    modal.hidden = false;
  }
}

if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      async onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        // Get form data for validation
        const formData = new FormData(this.form);
        const variantId = formData.get('id');
        const quantityToAdd = parseInt(formData.get('quantity') || '1');

        if(window.PreOrderValidator) {
          const validation = await PreOrderValidator.validateLimits(variantId, quantityToAdd);
          if (!validation.canAdd) {
            PreOrderValidator.showLimitMessage(validation.stockLimit, validation.currentQuantity, this.closest('.qty-buy-btn-cont'));
            return; // Stop if validation fails
          }
        }

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                    checkAndShowMixedCartModal(response);
                    checkAndShowWHSKUModal(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
              checkAndShowMixedCartModal(response);
              checkAndShowWHSKUModal(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
